// extracted by mini-css-extract-plugin
module.exports = {"container":"container-16juF","money":"money-2_R3C","from":"from-3zVXo","close":"close-a1Lpn"};